<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-content p-a-0">
      <div class="box has-text-dark p-a-lg">
        <h2 class="title is-3">Add an image from our selection</h2>
        <div class="modal-body">
          <div
            class="is-flex is-flex-wrap-wrap is-align-items-flex-start is-justify-content-flex-start"
          >
            <div
              class="control m-3"
              *ngFor="let imagePath of images; let i = index"
            >
              <label class="radio-input pl-0">
                <input
                  type="radio"
                  name="image-picker"
                  [value]="imagePath"
                  (change)="selectImage(imagePath)"
                />
                <span class="checkmark checkmark-img"></span>
                <i class="fas fa-check-circle is-size-4 has-text-link"></i>
                <img
                  [src]="storagePath + imagePath + '-videoCard.jpg'"
                  alt="Default image {{ i }}"
                />
              </label>
            </div>
          </div>
          <footer
            class="is-flex is-align-items-center is-justify-content-space-between m-t-lg"
          >
            <button
              (click)="modalClosed.emit()"
              class="button is-white-ter p-x-lg"
            >
              Cancel
            </button>
            <button
              class="button is-link"
              (click)="confirmSelection()"
              [disabled]="!selectedImage"
            >
              Confirm selection
            </button>
          </footer>
        </div>
      </div>
    </div>
  </div>
</div>
